import { TrendingTitle } from "../../components/hashTag/TrendingTitle";
import { HashtagRecentviews } from "../../components/hashTag/HashtagRecentviews";

export default function HashTagRecent() {
    return (
        <div className="h-full bg-[#000] relative overflow-hidden">
            <TrendingTitle title={"Recent"} />
            <div className=" mt-2 absolute w-full h-[-webkit-fill-available] overflow-scroll no-scrollbar">
                <HashtagRecentviews />
            </div>
        </div>
    );
}
